/**
 * Theme color mapping utility
 * Centralized theme color definitions for the application
 */

export const THEME_COLORS = {
  red: '#dc3545',
  pink: '#e91e63',
  salmon: '#FF6D4D',
  orange: '#fd7e14',
  yellow: '#ffc107',
  lime: '#84cc16',
  green: '#198754',
  teal: '#30D6A4',
  cyan: '#0dcaf0',
  blue: '#0d6efd',
  purple: '#6f42c1',
  indigo: '#6610f2',
  dark: '#212529'
};

export const DEFAULT_THEME_COLOR = '#30D6A4'; // teal

/**
 * Get the hex color code for a given theme name
 * @param {string} themeName - The theme name (e.g., 'red', 'blue', 'teal')
 * @returns {string} The hex color code
 */
export const getThemeColor = (themeName) => {
  return THEME_COLORS[themeName] || DEFAULT_THEME_COLOR;
};

/**
 * Check if a theme name is valid
 * @param {string} themeName - The theme name to validate
 * @returns {boolean} True if valid, false otherwise
 */
export const isValidTheme = (themeName) => {
  return Object.keys(THEME_COLORS).includes(themeName);
};

/**
 * Get all available theme names
 * @returns {string[]} Array of theme names
 */
export const getAvailableThemes = () => {
  return Object.keys(THEME_COLORS);
};

